import React, { useState } from 'react';
import { PERSONAL_LAYER } from '../data';

export default function PersonalLayer() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="personal" style={{ padding: '100px 0', borderTop: '1px solid rgba(26,26,26,0.06)' }}>
      <div style={{ padding: '0 12%' }}>
        <div className="fade-in" style={{ marginBottom: '56px' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.28em', color: 'var(--ink-mid)', textTransform: 'uppercase', marginBottom: '16px' }}>
            Outside Work
          </div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 64px)', fontWeight: 600, color: 'var(--ink)', lineHeight: 1, letterSpacing: '-0.03em', marginBottom: '12px' }}>
            The Human
          </h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--ink-light)', fontWeight: 300 }}>
            Because the best builders have lives outside the terminal.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1px', border: '1px solid rgba(26,26,26,0.08)' }}>
          {PERSONAL_LAYER.map((item, i) => (
            <div
              key={i}
              className="fade-in"
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                padding: '40px 28px',
                background: hovered === i ? 'rgba(26,26,26,0.02)' : 'transparent',
                transition: 'background 0.3s',
                cursor: 'default',
                textAlign: 'center',
                borderRight: i < PERSONAL_LAYER.length - 1 ? '1px solid rgba(26,26,26,0.08)' : 'none',
              }}
            >
              <div style={{
                fontSize: '36px', marginBottom: '20px',
                transform: hovered === i ? 'scale(1.15)' : 'scale(1)',
                transition: 'transform 0.3s',
              }}>
                {item.emoji}
              </div>
              <div style={{
                fontFamily: 'var(--font-display)', fontSize: '20px', fontWeight: 600,
                color: 'var(--ink)', letterSpacing: '-0.01em', marginBottom: '12px',
              }}>
                {item.label}
              </div>
              <div style={{
                fontFamily: 'var(--font-body)', fontSize: '13px', color: 'var(--ink-mid)',
                fontWeight: 300, lineHeight: 1.7,
                opacity: hovered === i ? 1 : 0.7,
                transition: 'opacity 0.3s',
              }}>
                {item.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
